import AbortTransactionMutation from '../../graphql/AbortTransaction';
import PlaceWithMethodMutation from '../../graphql/PlaceWithMethod';
import { CartTypeQuery } from '../../graphql/cart';

const abortTransactionMutation = (apolloClient) =>
  apolloClient.mutate({
    mutation: AbortTransactionMutation,
  });

const placeWithMethodMutation = (apolloClient, variables) =>
  apolloClient.mutate({
    mutation: PlaceWithMethodMutation,
    variables,
  });

const executeCartTypeCheckQuery = (apolloClient) =>
  apolloClient.query({
    query: CartTypeQuery,
    fetchPolicy: 'network-only',
  });

export {
  abortTransactionMutation,
  placeWithMethodMutation,
  executeCartTypeCheckQuery,
};
